<!-- edit widget popup -->
<div class="popup-bg edit-widget-popup d-block" id='forScroll'>
    <div class="popup">
        <div class="popup-content">
            <h3>Edit widget- {{editGraph}} {{subCompare?'('+subCompare+')':''}}</h3>
            <div class="alert-error" *ngIf="errorMessage.length>0">{{errorMessage}}</div>
            <div class="alert-success" *ngIf="successMessage.length>0">{{successMessage}}</div>
            <div class="alert-warning" *ngIf="warningMessage.length>0">{{warningMessage}}</div>
            <a href="javascript:void(0)" class="delete-icon"  (click)="forPopupClose()">
                <img src="assets/images/close-light-icon.svg" alt="">
            </a>
            <form class="form-wrap" [formGroup]="editGraphs">
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">KPI</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiList}">
                            <app-form-select-box [options]="kpiList && kpiList.length>0?kpiList:globalService.kpiList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                                [formElementName]="editGraphs" [controlName]="'scoreName_select_name'"
                                [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                [currentSelectedValue]="editGraphs['controls']['scoreName']['value']">
                            </app-form-select-box>
                        </div>
                    </div>
                    

                    <div class="input-wrap" *ngIf="globalService.orderType=='app' && cardName=='benchmarking'">
                        <span class="input-title">Choose Peers</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiselectAppsList}">
                                <!-- <app-form-select-box [options]="peers" [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                        [formElementName]="addGraph" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                    </app-form-select-box> -->
                                <ng-multiselect-dropdown name="selectedItems" [placeholder]="'Select'" [data]="globalService.multiselectAppsList" 
                                  formControlName="peersArray"  [settings]="dropdownSettings"></ng-multiselect-dropdown>
                            </div>
                            <a href="javascript:void(0)" class="info-icon"><img src="assets/images/info-icon.svg"
                                    alt=""></a>
                        </div>
                    
                  
                        <div class="input-wrap" *ngIf="globalService.orderType=='telco' && cardName=='benchmarking'">
                            <span class="input-title">Choose Peers</span>
                            <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectNetwork}">
                                <!-- <app-form-select-box [options]="peers" [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                        [formElementName]="addGraph" [controlName]="'peers_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                    </app-form-select-box> -->
                                <ng-multiselect-dropdown name="selectedItems" [placeholder]="'Select'" [data]="globalService.multiSelectNetwork" 
                                  formControlName="peersArray"  [settings]="dropdownSettings"></ng-multiselect-dropdown>
                            </div>
                            <a href="javascript:void(0)" class="info-icon"><img src="assets/images/info-icon.svg"
                                    alt=""></a>
                        </div>
                    



                    
                </div>


                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">From Date</span>
                        <div class="dropdown-wrap">
                            <ng-datepicker formControlName="startDate" name="startDate" [options]="options">
                            </ng-datepicker>
                        </div>

                    </div>
                    <div class="input-wrap">
                        <span class="input-title">To Date</span>

                        <ng-datepicker formControlName="endDate" name="endDate" [options]="options"></ng-datepicker>
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Time window</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':(!globalService.multiSelectTimeWindow) || (update=='updatetimeseries')}">
                            <ng-multiselect-dropdown [placeholder]="'Select'"
                                [data]="globalService.multiSelectTimeWindow" formControlName="timeWindowArray"
                                [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box  [options]="timeWindow" [isAllOptionShow]="true"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [formElementName]="editGraphs" [controlName]="'timeWindow_select_name'"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                        </app-form-select-box> -->
                        </div>

                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Location</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.dropdownList}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.dropdownList"
                                formControlName="locationArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="location"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [formElementName]="editGraphs" [controlName]="'location_select_name'" [isAllOptionShow]="true"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                             [currentSelectedValue]="editGraphs['controls']['location']['value']"
                            >
                        </app-form-select-box> -->
                        </div>
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap" *ngIf="update=='updatecompare' || update=='updatehistogram'">
                        <span class="input-title">Aggregator On </span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':! xValueList}">
                            <app-form-select-box [options]="xValueList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                                [formElementName]="editGraphs" [controlName]="'xValue_select_name'" [id]="'xValue'"
                                [isAllOptionShow]="false" [addCurrentSelectedValue]="false"
                                (currentSelectionChange)="changeSelection($event)"
                                [currentSelectedValue]="editGraphs['controls']['xValue']['value']">
                            </app-form-select-box>
                        </div>
                    </div>
                    <div class="input-wrap" *ngIf="update=='updatetimeseries'">
                        <span class="input-title">Choose Aggregator</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':! aggregationList}">
                            <app-form-select-box [options]="aggregationList" [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                                [formElementName]="editGraphs" [controlName]="'aggregation_select_name'"
                                [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                [currentSelectedValue]="editGraphs['controls']['aggregation']['value']">
                            </app-form-select-box>
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Speed</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectSpeed}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectSpeed"
                                formControlName="networkTagArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="networktag"
                            [dropDownIdKey]="'id'" [dropdownLabel]="'list'"
                            [formElementName]="editGraphs" [controlName]="'networktag_select_name'" [isAllOptionShow]="true"
                            [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)" 
                            [currentSelectedValue]="editGraphs['controls']['networktag']['value']"
                            >
                        </app-form-select-box> -->
                        </div>
                    </div>
                </div>

                <div class="input-row input-row-wide">
                    <div class="input-wrap" [ngClass]="{'disable-input':!globalService.multiSelectDeviceCategory}">
                        <span class="input-title">Device Class</span>
                        <div class="dropdown-wrap">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectDeviceCategory"
                            formControlName="deviceCategoryArray" [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="deviceCategory" [dropDownIdKey]="'id'"
                                [dropdownLabel]="'list'" [formElementName]="editGraphs"
                                [controlName]="'deviceCategory_select_name'" [isAllOptionShow]="true"
                                [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box> -->
                        </div>
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Name</span>
                        <input type="text" placeholder="mywidget1" name="widgetName" formControlName="widgetName" />
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <div class="input-wrap" *ngIf="globalService.orderType=='app'">
                        <span class="input-title">Choose Telcos</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectNetwork}">
                            <ng-multiselect-dropdown [placeholder]="'Select'" [data]="globalService.multiSelectNetwork"
                                formControlName="telcoArray" [settings]="dropdownSettings">
                            </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="networks" [dropDownIdKey]="'Network_id'" [dropdownLabel]="'list'" [isAllOptionShow]="true"
                                [formElementName]="editGraphs" [controlName]="'networks_select_name'" [addCurrentSelectedValue]="false" (currentSelectionChange)="changeSelection($event)"
                                [currentSelectedValue]="editGraphs['controls']['networks']['value']">
                            </app-form-select-box> -->
                        </div>
                    </div>
                    <div class="input-wrap" *ngIf="globalService.orderType=='telco'">
                        <span class="input-title">Choose Apps</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiselectAppsList}">  <ng-multiselect-dropdown [placeholder]="'Select'"
                            [data]="globalService.multiselectAppsList"
                             formControlName="appNameArray"
                            [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                            <!-- <app-form-select-box [options]="networks" [isAllOptionShow]="true"
                                [dropDownIdKey]="'Network_id'" [dropdownLabel]="'list'"
                                [formElementName]="addGraph" [controlName]="'networks_select_name'"
                                [addCurrentSelectedValue]="false"
                                (currentSelectionChange)="changeSelection($event)">
                            </app-form-select-box> -->
                        </div>
                    </div>
                    <div class="input-wrap">
                        <!-- <span class="input-title">Stream Type</span>
                        <div class="check-bar">
                            <div class="check check-radio">
                                <label class="custom-checkbox">
                                    <input type="radio" name="videoStreamType" formControlName="videoStreamType" [value]="true" required>
                                    <em class="checkmark"></em>
                                    <span class="check-text">Live</span>
                                </label>
                            </div>
                            <div class="check check-radio">
                                <label class="custom-checkbox">
                                    <input type="radio" name="videoStreamType" formControlName="videoStreamType" [value]="false" required>
                                    <em class="checkmark"></em>
                                    <span class="check-text">VOD</span>
                                </label>
                            </div>
                            <div class="invalid-feedback" *ngIf="isSubmitted && editGraphs['controls']['videoStreamType'].errors?.required">
                                <sup>*</sup>Please Choose Stream Type
                              </div>
                        </div> -->
                        <span class="input-title">Choose Platform</span>
                        <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.multiSelectPlatform}"> 
                             <ng-multiselect-dropdown [placeholder]="'Select'"
                            [data]="globalService.multiSelectPlatform"
                             formControlName="platformArray"
                            [settings]="dropdownSettings">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
            </div>
            <div class="input-row input-row-wide"  *ngIf="update !='updatehistogram'">
            <div class="input-wrap">
                <span class="input-title">KPI Type</span>  
               <div class="dropdown-wrap" [ngClass]="{'disable-input':!globalService.kpiType}">
                    <app-form-select-box  [options]="globalService.kpiType"
                        [dropDownIdKey]="'id'" [dropdownLabel]="'list'" [isDefaultOptionShowHidden]="'false'"
                        [formElementName]="editGraphs" [controlName]="'kpiType_select_name'"
                        [currentSelectedValue]="editGraphs['controls']['kpiType']['value']" (currentSelectionChange)="changeSelection($event)"
                        >
                    </app-form-select-box>
                </div>
            </div>
        </div>
                <div class="popup-links">
                    <button class="btn btn-light" (click)="deleteGraph(this.content,listData._id)">delete</button>
                    <button class="btn btn-dark" (click)="onSubmit($event)">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>